// Global Components
import * as React from 'react';

// Types
type $Props = {
  value: null | string;
};

const TdUrlView = function ({
  value,
}: $Props) {
  return (
    <td>
      {value !== null && (
        <a
          href={value}
          rel={'noreferrer'}
          target={'_blank'}
        >
          {value}
        </a>
      )}
    </td>
  );
};

export default TdUrlView;
